// extracted by mini-css-extract-plugin
module.exports = {"main":"Service-module--main--2K1zn","mobileImage":"Service-module--mobileImage--1Tl6E","desktopImage":"Service-module--desktopImage--3uaDV"};